/**
 * @generated SignedSource<<2d62ef64b860026e339ca7c6a503eb4c>>
 * @relayHash b21205896b56de61c144ea7d0548f80d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1d1b9f41b5612543ef58997db3b4d247971963f3a0117ac3fffe895483a45f2e

import type { ConcreteRequest } from 'relay-runtime';
export type useDraftsDataHomeDraftsQuery$variables = {
  after?: string | null;
  cqlcontext?: string | null;
  first?: number | null;
};
export type useDraftsDataHomeDraftsQuery$data = {
  readonly search: {
    readonly nodes: ReadonlyArray<{
      readonly content: {
        readonly blank: boolean;
        readonly editorVersion: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null;
            readonly key: string | null;
            readonly value: string | null;
          } | null> | null;
        } | null;
        readonly emoji: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null;
            readonly key: string | null;
            readonly value: string | null;
          } | null> | null;
        } | null;
        readonly excerpt: string;
        readonly id: string | null;
        readonly likes: {
          readonly count: number | null;
        } | null;
        readonly links: {
          readonly editui: string | null;
          readonly webui: string | null;
        } | null;
        readonly metadata: {
          readonly comments: {
            readonly commentsCount: number | null;
          } | null;
          readonly currentuser: {
            readonly favourited: {
              readonly isFavourite: boolean | null;
            } | null;
          } | null;
          readonly lastModifiedDate: string | null;
        };
        readonly space: {
          readonly alias: string | null;
          readonly id: string | null;
          readonly key: string | null;
          readonly name: string | null;
        } | null;
        readonly status: string | null;
        readonly subType: string | null;
        readonly title: string | null;
        readonly type: string | null;
      } | null;
    } | null> | null;
    readonly pageInfo: {
      readonly endCursor: string | null;
      readonly hasNextPage: boolean;
    } | null;
  } | null;
};
export type useDraftsDataHomeDraftsQuery = {
  response: useDraftsDataHomeDraftsQuery$data;
  variables: useDraftsDataHomeDraftsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cqlcontext"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = {
  "kind": "ScalarField",
  "name": "key"
},
v5 = [
  {
    "concreteType": "JsonContentProperty",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v3/*: any*/),
      (v4/*: any*/),
      {
        "kind": "ScalarField",
        "name": "value"
      }
    ]
  }
],
v6 = [
  {
    "alias": "search",
    "args": [
      {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
      },
      {
        "kind": "Literal",
        "name": "cql",
        "value": "type in (page,blogpost) order by lastModified desc"
      },
      {
        "kind": "Variable",
        "name": "cqlcontext",
        "variableName": "cqlcontext"
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      }
    ],
    "concreteType": "ConfluenceSearchConnection",
    "kind": "LinkedField",
    "name": "confluence_search",
    "plural": false,
    "selections": [
      {
        "concreteType": "ConfluenceSearchResponse",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "ScalarField",
                "name": "title"
              },
              {
                "kind": "ScalarField",
                "name": "type"
              },
              {
                "kind": "ScalarField",
                "name": "subType"
              },
              {
                "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "webui"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "editui"
                  }
                ]
              },
              {
                "args": [
                  {
                    "kind": "Literal",
                    "name": "length",
                    "value": 372
                  }
                ],
                "kind": "ScalarField",
                "name": "excerpt",
                "storageKey": "excerpt(length:372)"
              },
              {
                "concreteType": "ContentMetadata",
                "kind": "LinkedField",
                "name": "metadata",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                    "kind": "LinkedField",
                    "name": "currentuser",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "FavouritedSummary",
                        "kind": "LinkedField",
                        "name": "favourited",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "isFavourite"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "concreteType": "ContentMetadata_CommentsMetadataProvider_comments",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "commentsCount"
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "lastModifiedDate"
                  }
                ]
              },
              {
                "concreteType": "Space",
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "alias"
                  },
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "name"
                  }
                ]
              },
              {
                "concreteType": "LikesResponse",
                "kind": "LinkedField",
                "name": "likes",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "count"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "status"
              },
              {
                "kind": "ScalarField",
                "name": "blank"
              },
              {
                "alias": "editorVersion",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "key",
                    "value": "editor"
                  }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": (v5/*: any*/),
                "storageKey": "properties(key:\"editor\")"
              },
              {
                "alias": "emoji",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "keys",
                    "value": [
                      "emoji-title-draft"
                    ]
                  }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": (v5/*: any*/),
                "storageKey": "properties(keys:[\"emoji-title-draft\"])"
              }
            ]
          }
        ]
      },
      {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "hasNextPage"
          },
          {
            "kind": "ScalarField",
            "name": "endCursor"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useDraftsDataHomeDraftsQuery",
    "selections": (v6/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useDraftsDataHomeDraftsQuery",
    "selections": (v6/*: any*/)
  },
  "params": {
    "cacheID": "b21205896b56de61c144ea7d0548f80d",
    "id": "1d1b9f41b5612543ef58997db3b4d247971963f3a0117ac3fffe895483a45f2e",
    "metadata": {},
    "name": "useDraftsDataHomeDraftsQuery",
    "operationKind": "query",
    "text": "query useDraftsDataHomeDraftsQuery($cqlcontext:String,$first:Int,$after:String){search:confluence_search(cql:\"type in (page,blogpost) order by lastModified desc\",cqlcontext:$cqlcontext,first:$first,after:$after){nodes{content{id,title,type,subType,links{webui,editui},excerpt(length:372),metadata{currentuser{favourited{isFavourite}},comments{commentsCount},lastModifiedDate},space{alias,id,key,name},likes{count},status,blank,editorVersion:properties(key:\"editor\"){nodes{id,key,value}},emoji:properties(keys:[\"emoji-title-draft\"]){nodes{id,key,value}}}},pageInfo{hasNextPage,endCursor}}}"
  }
};
})();

(node as any).hash = "7618e5a200bb793a16a7e96fb74bdb29";

export default node;
